import { ActionTypes } from 'actionsConstants';

export function fetchOsDesignConfigInitDataRequest(
    payload) {
    return {
      type: ActionTypes.OS_DESIGN_CONFIG_INIT_DATA_REQUEST,
      payload: {
        payload
      },
    }
}


export function IMPORT_OS_PROJECT_FAILED() {
    return {
      type: ActionTypes.IMPORT_OS_PROJECT_FAILED,
    };
  }

  export function IMPORT_OS_FULL_DESIGN_PROJECT(data: any = {}) {
    return {
      type: ActionTypes.IMPORT_OS_FULL_DESIGN_PROJECT,
      payload: {
        data,
      },
    };
  }
  
  export function IMPORT_OS_PROJECT_SUCCESS(projectData: any = {}) {
    return {
      type: ActionTypes.IMPORT_OS_PROJECT_SUCCESS,
      payload: {
        projectData,
      },
    };
  }

  export function REDIRECT_OS_PAGE() {
    return {
      type: ActionTypes.REDIRECT_OS_PAGE,
    };
  }

  export function SET_OS_BACKGROUND_VISIBLE() {
    return {
      type: ActionTypes.SET_OS_BACKGROUND_VISIBLE,
    };
  }

  export function CLEAR_OS_BACKGROUND_VISIBLE() {
    return {
      type: ActionTypes.CLEAR_OS_BACKGROUND_VISIBLE,
    };
  }
